import { render } from "./Orders.vue?vue&type=template&id=5462dc84"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import exportComponent from "/home/irevors/CODING/ESTUDIOS/SENCE/ensayo prueba TD/ensayo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__